<template>
    <entity-list
        entity="encounter"
        api-name="encounters"
        :use-events="true"
        :entity-sort="encounterSort"
        new-route-name="newEncounter"
        :event-id="eventId"
        :team-id="teamId"
        isArchive
        hide-status
        :entityHeaders="headers"
    >
        <template v-slot:[`item.day`]="{ item }">
            {{ getEncounterDayAndTime(item) }}
        </template>
    </entity-list>
</template>
<script>
import EntityList from '../../components/EntityList'
import { DateTime } from 'luxon'
import { sortBy } from 'lodash'
export default {
    name: 'EncounterArchive',
    components: {
        'entity-list': EntityList,
    },
    props: {
        eventId: {
            type: [String, Number],
            required: false,
        },
        teamId: {
            type: [String, Number],
            required: false,
        },
    },
    data() {
        return {
            researchPeriods: [],
            headers: [
                {
                    text: 'Name',
                    align: 'start',
                    value: 'name',
                    width: '25%',
                },
                {
                    text: 'Date/Time',
                    align: 'start',
                    value: 'day',
                    width: '20%',
                },
                { text: 'Main Team', value: 'teamName', filterable: false, width: '20%' },
                { text: 'Archive Date', value: 'createdDate', filterable: false, width: '20%' },
            ],
        }
    },
    methods: {
        getEncounterDayAndTime(encounter) {
            return this.getTimeStamp(encounter.day.date, encounter.timeAsMinutes)
        },
        getTimeStamp(date, time) {
            if (!this.isValidDate(date)) return
            let dateOnly = DateTime.fromISO(date, { zone: 'utc' })
            let dateTime = dateOnly.plus({ minutes: time })
            return `${dateOnly.toFormat('ccc')} ${dateTime.toLocaleString(DateTime.TIME_24_SIMPLE)}`
        },
        isValidDate(value) {
            if (!value || value === 'Invalid DateTime' || (DateTime.isDateTime(value) && !value.isValid)) {
                return false
            }
            return true
        },
        encounterSort(encounters) {
            return sortBy(encounters, ['day.date', 'timeAsMinutes'])
        },
    },
}
</script>
